import { Controller } from "@hotwired/stimulus";

// Live client-side filter for the bank-institution picker on the guest
// explore page. Replaces the Alpine `x-model`/`x-show` search in
// `_pick_institution.html.erb`. The partial is re-rendered through Turbo
// (`turbo_stream` update), so the controller reconnects on each render.
export default class extends Controller {
  static targets = ["input", "row"];

  filter() {
    const query = this.inputTarget.value.trim().toLowerCase();
    this.rowTargets.forEach((row) => {
      const name = row.dataset.name ?? "";
      row.classList.toggle("hidden", query !== "" && !name.includes(query));
    });
  }
}
